<template>
	<div class="bg-music flex justify-center flex-direction align-center">
		<audio :src="music" loop="true" ref="music" controls="controls" @play="onPlay" @pause="onPause" @ended="onStop" @error="onError"></audio>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	computed: {
		...mapGetters(['isPlay'])
	},
	props: {
		music: String
	},
	watch: {
		music(newVal) {}
	},
	data() {
		return {};
	},
	methods: {
		switch() {
			if (this.isPlay) {
				this.stop();
			} else {
				this.play();
			}
		},
		play(){
			if(this.music){
				this.$refs['music'].play();
			}
		},
		stop(){
			if(this.music){
				this.$refs['music'].pause();
			}
		},
		onPlay() {
			this.$store.commit('play');
		},
		onPause() {
			this.$store.commit('stop');
		},
		onStop() {
			this.$store.commit('stop');
		},
		onError() {
			this.$store.commit('stop');
		}
	},
	mounted() {
		let context = this.$refs['music'];
	}
};
</script>

<style lang="scss" scoped>
.bg-music {
	position: fixed;
	top: 0;
	left: 0;
	width: 0;
	height: 0;
	overflow: hidden;
	audio {
		width: 7rem;
		margin-left: 0.25rem;
		margin-right: 0.25rem;
		box-sizing: border-box;
	}
}
</style>
